import apiHelper from '@/services/helper'

const getSubscription = async ({ userId }) => {
    try {
        let url = `/admin/subscription/users/${userId}`
        return (await apiHelper.getWithFirebaseToken(url)).data
    } catch (error) {
        throw new Error(error)
    }
}

const getValidateSubscription = async ({ userId, cycle }) => {
    try {
        let url = `/admin/subscription/users/${userId}/validate-period?cycle=${cycle}`
        return (await apiHelper.getWithFirebaseToken(url)).data
    } catch (error) {
        throw new Error(error)
    }
}

const putSubscription = async ({ userId, param }) => {
    try {
        let url = `/admin/subscription/users/${userId}`
        return (await apiHelper.putWithFirebaseToken(url, param)).data
    } catch (error) {
        throw new Error(error)
    }
}

const customerExport = async (param) => {
    try {
        let url = '/admin/subscription/customer/export'
        return (await apiHelper.postWithFirebaseToken(url, param)).data
    } catch (error) {
        throw new Error(error)
    }
}

const approvedCustomerExport = async (param) => {
    try {
        let url = '/admin/subscription/approved/export'
        return (await apiHelper.postWithFirebaseToken(url, param)).data
    } catch (error) {
        throw new Error(error)
    }
}
const confirmCustomerExport = async (param) => {
    try {
        let url = '/admin/subscription/confirm/export'
        return (await apiHelper.postWithFirebaseToken(url, param)).data
    } catch (error) {
        throw new Error(error)
    }
}
const leadpoolCustomerExport = async (param) => {
    try {
        let url = '/admin/subscription/leadpool-customer/export'
        return (await apiHelper.postWithFirebaseToken(url, param)).data
    } catch (error) {
        throw new Error(error)
    }
}
const getPackage = async () => {
    try {
        let url = '/admin/subscription/packages'
        return (await apiHelper.getWithFirebaseToken(url)).data
    } catch (error) {
        throw new Error(error)
    }
}
const calculateQuotation = async (param) => {
    try {
        let url = '/admin/subscription/payments/quotation/calculate'
        return (await apiHelper.postWithFirebaseToken(url, param)).data
    } catch (error) {
        throw new Error(error)
    }
}

export default {
    getSubscription,
    getValidateSubscription,
    putSubscription,
    leadpoolCustomerExport,
    customerExport,
    approvedCustomerExport,
    confirmCustomerExport,
    getPackage,
    calculateQuotation
}
